
import get from 'lodash/get';
// TODO:BRO-1276: import DDropdownItem from '@appsumo/dorado-nuxt';
import LegacyDropdown from '../../ui/LegacyDropdown.vue';

export default {
  name: 'PDPCommentReview',
  components: {
    LegacyDropdown,
  },
  props: {
    isValid: {
      type: Boolean,
    },
    rating: {
      type: Number,
      default: 5,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hoverRating: -1,
      ratingsList: [
        { value: 5, display: '5 tacos' },
        { value: 4, display: '4 tacos' },
        { value: 3, display: '3 tacos' },
        { value: 2, display: '2 tacos' },
        { value: 1, display: '1 taco' },
      ],
      tacoClasses: [
        'taco-click-1',
        'taco-click-2',
        'taco-click-3',
        'taco-click-4',
        'taco-click-5',
      ],
    };
  },
  computed: {
    ratingStyle() {
      const IMG_WIDTH = 32;

      let style = {
        width: `${this.rating * IMG_WIDTH}px`,
      };

      if (this.hoverRating > -1) {
        style = {
          width: `${this.hoverRating * IMG_WIDTH}px`,
          filter: 'contrast(1.3)',
        };
      }

      return style;
    },
    dropdownLabel() {
      return get(this.ratingsList, [Math.abs(this.rating - 5), 'display'], this.rating);
    },
  },
  methods: {
    onClickTaco(index) {
      this.$emit('update-rating', index);
    },

    onClickDropdown({ value }) {
      this.onClickTaco(value);
    },

    onMouseEnter(index) {
      this.hoverRating = index;
    },

    onMouseLeave() {
      this.hoverRating = -1;
    },

    onInputChange(e) {
      this.$emit('on-change-title', e.target.value);
    },
  },
};
